import { AxiosResponse } from 'axios'
import { generalServiceAPI } from '@/store/api-instance'
import { IGetContainersRequest } from '../interfaces/getContainers/IGetContainersRequest'
import { IGetContainersResponse } from '../interfaces/getContainers/IGetContainersResponse'

export const cmAPI = {
  async fetchContainers (dto: IGetContainersRequest): Promise<IGetContainersResponse> {
    const response: AxiosResponse = await generalServiceAPI.get<IGetContainersRequest>('container', { params: dto })
    return response.data
  },
  async updateContainers (dto: any): Promise<any> {
    const response: AxiosResponse = await generalServiceAPI.post<any>('container', dto)
    return response.data
  }
}
